import type { IconProps } from "@lib/common/components/Icon/Icon";
import Icon from "@lib/common/components/Icon/Icon";

export default function AgentIcon({ ...props }: Pick<IconProps, "size">) {
  return <Icon name="sparkle" color="var(--mantine-primary-color-filled)" variant="solid" {...props} />;
}
